import { Report } from "@/types/report";
import { useMemo } from "react";
import BigNumber from "bignumber.js";

interface BalancesInput {
    accounts: Report["accounts"];
    assets: Report["assets"];
    debts: Report["debts"];
}

const useBalances = ({ accounts, assets, debts }: BalancesInput) => {
    return useMemo(() => {
        const accountsBalances = accounts.reduce(
            (acc, current) => ({
                startBalance: acc.startBalance.plus(current.startAmount),
                endBalance: acc.endBalance.plus(current.endAmount),
            }),
            { startBalance: new BigNumber(0), endBalance: new BigNumber(0) },
        );

        const assetsBalances = assets.reduce(
            (acc, current) => ({
                startBalance: acc.startBalance.plus(current.startAmount),
                endBalance: acc.endBalance.plus(current.endAmount),
            }),
            { startBalance: new BigNumber(0), endBalance: new BigNumber(0) },
        );

        const debtsBalances = debts.reduce(
            (acc, current) => ({
                startBalance: acc.startBalance.plus(current.startAmount),
                endBalance: acc.endBalance.plus(current.endAmount),
            }),
            { startBalance: new BigNumber(0), endBalance: new BigNumber(0) },
        );

        return {
            accountsBalances,
            assetsBalances,
            debtsBalances,
        };
    }, [accounts, assets, debts]);
};

export { useBalances };
